export const ELEMENT = 'element';
export const ELEMENT_PLACEHOLDER = 'element_placeholder';
export const LAYOUT = 'layout';
export const SECTION = 'section';
export const SAVE_SECTION = 'save_section';
export const RESIZE_HANDLE = 'resize_handle';
export const COMMENTABLE_AREA = 'commentable_area';